<template>
  <div>
    <div class="page-title">
      Financial Settings
    </div>
    <div class="page-container">
      <div class="filter-right-container" style="height: 24px;">
        <div class="filter-container-tag">
          {{ $t('components.banks') }}
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-for="(item,index) in componentConfig" :key="index" :label="item.label" :name="item.compName" />
        </el-tabs>
        <component :is="activeName" :key="activeName" @changeComponent="changeComponent" />
      </div>
    <!-- <ReviewResultModal /> -->
    </div>
  </div>
</template>

<script>

import { getIsJTMerchant } from '@/api/data/data'

export default {
  name: 'Financial-Setting',
  components: {
    BankAccountList: () => import('./components/BankAccountList.vue'),
    CashOutSetting: () => import('./components/CashOutSetting.vue')
    // ReviewResultModal: () => import('@/layout/components/Modal/ReviewResultModal.vue')
  },
  data() {
    this.SETTLEMENT_TYPE = {
      local: 1,
      usd: 2
    }
    return {
      isJTMerchant: false,
      activeName: 'BankAccountList'
    }
  },
  computed: {
    componentConfig() {
      if (this.$store.state.user.isJtMerchant || this.$store.state.user.isCargoMerchant) {
        return [
          { compName: 'BankAccountList', label: this.$t('data.bank_account_list') }
        ]
      } else {
        return [
          { compName: 'BankAccountList', label: this.$t('data.bank_account_list') },
          { compName: 'CashOutSetting', label: this.$t('data.cash_out_settng') }
        ]
      }
    }
  },
  created() {
    this.$bus.emit('GET_NOTIFY')
    // this.getIsJTMerchant()
    // const { status } = this.$route.query
    // if (status) {
    //   this.activeName = this.statusArr[status]
    // }
  },
  methods: {
    getIsJTMerchant() {
      getIsJTMerchant().then(res => {
        this.isJTMerchant = res.data
      })
    },
    changeComponent(obj) {
      this.activeName = obj.compName
    }
  }
}
</script>

<style scoped>
</style>
